"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DAYS_OF_THE_WEEK = exports.CLOSED_DAY = void 0;
var CLOSED_DAY = exports.CLOSED_DAY = 'Closed';
var DAYS_OF_THE_WEEK = exports.DAYS_OF_THE_WEEK = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];